import { render, staticRenderFns } from "./CorrectStat.vue?vue&type=template&id=4b89ca45&scoped=true&"
import script from "./CorrectStat.vue?vue&type=script&lang=js&"
export * from "./CorrectStat.vue?vue&type=script&lang=js&"
import style0 from "./CorrectStat.vue?vue&type=style&index=0&id=4b89ca45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b89ca45",
  null
  
)

export default component.exports